<template>
  <div class="page plr16">
    <div class="page-head">
      <div class="mains-content">
        <div class="tops-between">
          <div class="tops-title">
            <p>套餐顾客管理</p>
          </div>
        </div>
        <div class="member-content-box">
          <div class="member-header">
            <div class="flex-row">
              <el-select v-model="query.sourceFrom" size="small" class="small-btn mr10" @change="onChange">
              <el-option label="纸质套餐" value="paper"></el-option>
              <el-option label="电子套餐" value="card430"></el-option>
            </el-select>
              <el-input
                placeholder="请输入手机号码/姓名"
                v-model="query.keyword"
                clearable
                @clear="removeDoQuery"
                @keyup.enter.native="rulesMobile"
                class="input-with-select"
                prefix-icon="el-icon-search"
              ></el-input>
              <el-button type="primary" @click="rulesMobile" style="height: 48px;">搜索</el-button>
            </div>
            
            <el-button type="primary" class="small-btn" @click="addClick()" style="height: 48px;">新增</el-button>
          </div>
          <el-table :data="list" max-height="475px" :summary-method="getSummaries" show-summary>
            <el-table-column
              :prop="index"
              :align="item.align"
              :label="item.label"
              :width="item.width"
              :min-width="item.minWidth"
              :show-overflow-tooltip="false"
              v-for="(item,index) in columns"
              :key="index"
            >
              <template slot-scope="scope">
                <div>{{Boolean(item.formatDay)?formatDay(scope.row[index]):scope.row[index]}}</div>
              </template>
            </el-table-column>
            <el-table-column prop="amt" label="操作" align="center" width="100" fixed="right">
              <template slot-scope="scope">
                <el-link type="primary" @click="addClick(scope.row)">编辑</el-link>
                <el-link type="primary" class="ml10" @click="detailPage(scope.row)">详情</el-link>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="mains-bottom">
        <div class="back el-icon-back" @click="back"></div>
        <paging :totalCount="totalCount" @doPageQuery="doDataQuery"></paging>
      </div>
    </div>
    <edit-set ref="editSetForm" @change="editChange"></edit-set>
    <detail-set ref="detailSetForm"></detail-set>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import config from "./config/columns";
import editSet from "./edit";
import detailSet from "./detail";
export default {
  mixins: [minxin],
  data() {
    return {
      columns: config.columns,
      list: [],
      url: this.$url.cardOldBook.list,
      query: {
        keyword: "",
        sourceFrom: "paper",
        size: 20,
        start: 1
      },
      totals: {}
    };
  },
  components: {
    editSet,
    detailSet
  },
  created() {
    this.totalCounts();
    this.getTotal()
  },
  methods: {
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        sums[0] = "汇总";
        sums[4] = this.totals.originNum;
        sums[5] = this.totals.useNum;
      });
      return sums;
    },
    getTotal () {
      this.$api.post(this.$url.cardOld.cardTotal,this.query).then(res => {
          this.totals = res;
      })
    },
    // cardOld.cardTotal
    back() {
      this.$router.push("/dataList/paperSetMeal");
    },
    addClick(item) {
      item == undefined
        ? this.$refs["editSetForm"].$emit("set", null)
        : this.$refs["editSetForm"].$emit("set", item);
    },
    rulesMobile() {
      if (this.query.keyword != "") {
        this.list = [];
        this.query.start = 1;
        this.totalCounts();
        this.getTotal();
      } else {
        this.$message.error("请输入手机号码/姓名")
      }
    },
    onChange () {
      this.totalCounts();
      this.getTotal();
    },
    totalCounts () {
      this.totalCount = 0;
      this.$api.post(this.$url.cardOldBook.count, this.query).then(res => {
        this.getData();
        this.totalCount = res;
      }).catch(error => {});
    },
    removeDoQuery() {
      this.query = {
        keyword: "",
        start: 1,
        size: 20
      };
      this.totalCounts();
      this.getTotal();
    },
    editChange(bool) {
      if (bool) {
        this.query = {
          keyword: "",
          start: 1,
          size: 20
        };
        this.totalCounts();
        this.getTotal();
      }
    },
    detailPage(item) {
      this.$refs["detailSetForm"].$emit("set", item);
    }
  }
};
</script>

<style scoped lang="less">
@import "../../../assets/css/edit.less";
.page-head {
  height: 100%;
}

.mains-bottom {
  
  .back {
    position: absolute;
    left: 26px;
  }
  width: calc(100% - 30px);
  position: absolute;
  background-color: #fff;
  height: 62px;
  margin-top: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  bottom: 15px;
}
.mains-content {
  height: calc(100% - 72px);
  .tops-between {
    background: #fff;
    display: flex;
    justify-content: space-between;
    padding: 0 25px;
    align-items: center;
    // border-bottom: 2px solid @borderColor;
  }
  .tops-title {
    width: 100%;
    box-sizing: border-box;

    p {
        font-weight: bold;
      font-size: 18px;
      height: 60px;
      line-height: 60px;
      span {
        color: @blue;
      }
    }
    .add-btns {
      width: 100px;
      height: 32px;
    }
  }
  .member-content-box {
    // padding: 0 25px;
    margin-top: 10px;
    .member-header {
      background-color: #fff;
      height: 80px;
      padding: 0 26px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 2px solid @borderColor;
      .input-with-select {
        width: 404px;
        height: 48px;
        margin-right: 15px;
        /deep/ .el-input__inner {
          height: 48px;
          line-height: 48px;
          padding-left: 35px;
        }
        /deep/ .el-input__clear {
          font-size: 22px;
          line-height: 48px;
        }
        /deep/ .el-input__prefix {
          color: @blue;
          font-size: 24px;
          margin-right: 10px;
          .el-input__icon {
            line-height: 48px;
          }
        }
      }
    }
  }
  .member-header {
    height: 80px;
    padding: 0 26px;
    display: flex;
    align-items: center;
    border-bottom: 2px solid @borderColor;
    .input-with-select {
      width: 404px;
      height: 48px;
      margin-right: 15px;
      /deep/ .el-input__inner {
        height: 48px;
        line-height: 48px;
        padding-left: 35px;
      }
      /deep/ .el-input__clear {
        font-size: 22px;
        line-height: 48px;
      }
      /deep/ .el-input__prefix {
        color: @blue;
        font-size: 24px;
        margin-right: 10px;
        .el-input__icon {
          line-height: 48px;
        }
      }
    }
  }
}
</style>